export default {
  heading: "Account Association",
  info: "Linking your school-based accounts to memberships owned by you, so that you will have full control over your own account and will be able to view your complete user profile and activity history at EdCity regardless of which class or school they teach or attend.",
  associateFromHeading: "Please enter the login ID and password of the account to be associated.",
  associatedActiveHeading:"Active associated account",
  listHeading: "List of associated legacy accounts",
  label: {
    password: "Password",
    closeBtn: "Close",
    actions: "Actions",
  },
  button: {
    remove: "Remove Association",
  },
  validations: {
    passwordIsEmpty: "Please fill in the password of the association account.",
    passwordInvalid: "The password is invalid",
    cityIdIsEmpty: "Please fill in the Login Id of the association account.",
    cityIdInvalid: "The Login Id is invalid",
  },
  serverErrors: {
    wrongPasswordOrUserNotFound: "The account does not exist or the password is incorrect",
    notStudent: "Only student accounts can be associated",
    inactiveAssociateAccount: "Cannot unassocaite",
    alreadyHasActiveAssociation: "student account is associated",
    non_full_member: "Your account cannot be associated to other accounts",
    invalid_relationship_nature: "Only student account can be associated",
    duplicated_relationship_nature: "Cannot be associated repeatedly",
    not_exist_user_relationship: "The relationship is not exist",
  },
  confirmDialog: {
    associate: {
      content: "Confirm associate?",
      confirm: "Confirm",
      cancel: "Cancel",
    },
    remove: {
      content: "Confirm unassociate?",
      confirm: "Confirm",
      cancel: "Cancel",
    },

  },

};
